import {IApiRoute} from '../../@interfaces/services/Router';
import AbstractRoute from './AbstractRoute';
import {HTTPMethods} from '../../@interfaces/http/HTTPMethods';

export default class ApiRoute extends AbstractRoute<IApiRoute> implements IApiRoute {
	protected uri: string | null = null;
	protected methods: HTTPMethods[] = [];

	getMethods(): HTTPMethods[] {
		return this.methods;
	}

	getUri(): string | null {
		return this.uri;
	}

	setMethods(methods: HTTPMethods[]): IApiRoute {
		this.methods = methods;

		return this;
	}

	setUri(uri: string): IApiRoute {
		this.uri = uri;

		return this;
	}

	protected getRouteUri(): string {
		return this.getUri() || '';
	}
}
